import MediaGrid from "./MediaGrid";

export default MediaGrid;